export const getDisplayOption = (data) => {
    const hasAlignedStl = !!data?.alignedStlUrl;
    const hasCbct = !!data?.alignedStlCbctUrl;

    if (hasAlignedStl && hasCbct) return "ROOTS_BONES";
    if (hasAlignedStl && !hasCbct) return "ROOTS";
    if (!hasAlignedStl && hasCbct) return "ROOTS_BONES";
    return "GUM";
};

export const getRootsTooltip = (data, toggle , getContent) => {
    if (!toggle.hasRoots) {
        return getContent("tooltips", "roots_arent_supported_with_this_ts");
    }

    if (toggle.occ) {
        return getContent("tooltips", "disable_roots_note_with_occ");
    }
    if(toggle.pontics){
        return getContent("tooltips", "disable_roots_note_with_pontics");

    }


    const displayMode = getDisplayOption(data);

    switch (displayMode) {
        case "ROOTS_BONES":
            return getContent("tooltips", "show_roots_and_bones");
        case "ROOTS":
            return getContent("tooltips", "show_simulated_roots");
        default:
            return null;
    }
};